import * as React from "react";
import { cn } from "../../lib/utils";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from "../ui/navigation-menu";
import {
  BadgeCheck,
  ChevronRight,
  CreditCard,
  LogOut,
  Menu,
  Sparkles,
} from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "../ui/sheet";
import { Button } from "../ui/button";
// import { Input } from "../ui/input";
import { Link, useNavigate, useParams } from "react-router-dom";
// import favLogo from "../../assets/images/logo.png";
import { OrganizationSwitcher } from "./OrganizationSwitcher";
import LogoSVG from "../LogoSVG";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "../ui/collapsible";
import { SidebarMenuSub } from "../ui/sidebar";
import { TrustSwitcher } from "./TrustSwitcher";
import { useOrganization } from "../../lib/context/OrganisationContext";
import { ThemeToggle } from "../ThemeToggle";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { API, get } from "../../config";
import { toast } from "../ui/use-toast";
import { getModuleNamingBySlug } from "../../lib/Misc";
import {
  LawyerConditon,
  InvoiceModuleConditon,
  AMLCTFModuleConditonIndustry,
} from "../../lib/PermissionConditions";
import { useUser } from "../../lib/context/UserContext";

export function MainNavbar({ trigger }) {
  const pathname = window.location.pathname;
  const params = useParams();
  const trustId = params?.trust_id;
  const { organizationData } = useOrganization();
  const navigate = useNavigate();
  const { userData } = useUser();

  const [openInvoiceSubMenu, setOpenInvoiceSubMenu] = React.useState(false);

  const profilePic = localStorage.getItem("ProfilePhoto");
  // const navigate = useNavigate();
  const roleType = localStorage.getItem("roleType");

  const initials = localStorage
    ?.getItem("Name")
    ?.split(" ")
    ?.map((word) => word?.charAt(0)?.toUpperCase())
    ?.join("");

  const user = {
    name: localStorage?.getItem("Name"),
    email: localStorage?.getItem("ts-auth-email"),
    avatar: profilePic,
    initials: initials,
  };

  const logOut = async () => {
    get(API.LOGOUT)
      .then((response) => {
        if (response.status === 200) {
          localStorage.clear();
          window.location.href = "/";
        }
      })
      .catch(() => {
        toast({
          variant: "destructive",
          description:
            "There is some issue with request, please try after some time.",
          duration: 3000,
        });
      });
  };

  let assetManagementMenu = [
    {
      title: getModuleNamingBySlug(
        organizationData?.organizationData,
        "assets",
        "Asset",
      ),
      href: `/trusts/${trustId}/assets`,
      description: "Assets",
    },
    {
      title: getModuleNamingBySlug(
        organizationData?.organizationData,
        "sub-assets",
        "Sub Asset",
      ),
      href: `/trusts/${trustId}/sub-assets`,
      description: "Sub Assets",
    },
    {
      title: "Contract",
      href: `/trusts/${trustId}/contracts`,
      description: "Contracts",
    },
    {
      title: "Jobs",
      href: `/trusts/${trustId}/jobs`,
      description: "Jobs",
    },
    {
      title: "Tasks",
      href: `/trusts/${trustId}/tasks`,
      description: "Tasks",
    },
  ];

  if (LawyerConditon(organizationData)) {
    assetManagementMenu = assetManagementMenu?.filter(
      (item) => item.description !== "Jobs" && item.description !== "Tasks",
    );
  }

  let settingsMenu =
    organizationData?.organizationData?.is_subscribed ||
    organizationData?.organizationData?.is_aml_ctf_subscribed
      ? trustId
        ? [
            {
              title: "General Settings",
              href: !trustId
                ? "/general-settings"
                : `/trusts/${trustId}/trust-general-settings`,
              description: "General Settings",
            },
            {
              title: "User Activity",
              // href: !trustId ? "/users" : `/trusts/${trustId}/users`,
              href: "/user-activities",
              description: "User Activity",
            },
            {
              title: "Users",
              // href: !trustId ? "/users" : `/trusts/${trustId}/users`,
              href: "/users",
              description: "Users",
            },
            {
              title: "Offices",
              // href: !trustId ? "/offices" : `/trusts/${trustId}/offices`,
              href: "/offices",
              description: "Offices",
            },
            {
              title: "Support Ticket",
              href: !trustId
                ? "/support-tickets"
                : `/trusts/${trustId}/trust-support-tickets`,
              description: "Support Ticket",
            },
            {
              title: "FAQs",
              href: "/faqs",
              description: "FAQs",
            },
            {
              title: "Opening Balance",
              href: `/trusts/${trustId}/opening-balances`,
              description: "Opening Balance",
            },
          ]
        : [
            {
              title: "General Settings",
              href: !trustId
                ? "/general-settings"
                : `/trusts/${trustId}/trust-general-settings`,
              description: "General Settings",
            },
            {
              title: "User Activity",
              // href: !trustId ? "/users" : `/trusts/${trustId}/users`,
              href: "/user-activities",
              description: "User Activity",
            },
            {
              title: "Users",
              // href: !trustId ? "/users" : `/trusts/${trustId}/users`,
              href: "/users",
              description: "Users",
            },
            {
              title: "Offices",
              // href: !trustId ? "/offices" : `/trusts/${trustId}/offices`,
              href: "/offices",
              description: "Offices",
            },
            {
              title: "Support Ticket",
              href: !trustId
                ? "/support-tickets"
                : `/trusts/${trustId}/trust-support-tickets`,
              description: "Support Ticket",
            },
            {
              title: "FAQs",
              href: "/faqs",
              description: "FAQs",
            },
          ]
      : [
          {
            title: "General Settings",
            href: !trustId
              ? "/general-settings"
              : `/trusts/${trustId}/trust-general-settings`,
            description: "General Settings",
          },
          {
            title: "Support Ticket",
            href: !trustId
              ? "/support-tickets"
              : `/trusts/${trustId}/trust-support-tickets`,
            description: "Support Ticket",
          },
          {
            title: "FAQs",
            href: "/faqs",
            description: "FAQs",
          },
        ];

  // trustId &&
  //   settingsMenu?.push({
  //     title: "Documents",
  //     href: `/trusts/${trustId}/documents`,
  //     description: "Documents",
  //   });

  settingsMenu = trustId
    ? settingsMenu?.filter(
        (item) => item?.href !== "/users" && item?.href !== "/offices",
      )
    : settingsMenu;

  const accountingMenu = [
    {
      title: "Journal Entries",
      href: `/trusts/${trustId}/journal-entries`,
      description: "Journal Entries",
    },
    {
      // title: "Enter Trust Receipts",
      title: "Receipts / Deposit Records",
      href: `/trusts/${trustId}/receipts`,
      description: "Receipts",
    },
    {
      title: "Enter Trust Payments",
      href: `/trusts/${trustId}/payments`,
      description: "Payments",
    },
    // {
    //   title: "Chart Of Accounts",
    //   href: `/trusts/${trustId}/chart-of-accounts`,
    //   description: "Chart Of Accounts",
    // },
  ];

  const invoicingMenu = [
    // {
    //   title: "Processing Fee Codes",
    //   href: `/trusts/${trustId}/processing-fees`,
    //   description: "Processing Fee Codes",
    // },
    // {
    //   title: "Discount Codes",
    //   href: `/trusts/${trustId}/discount-codes`,
    //   description: "Discount Codes",
    // },
    {
      title: "Invoices",
      href: `/trusts/${trustId}/invoices`,
      description: "Invoices",
    },
    {
      title: "Invoice Tools",
      children: [
        {
          title: "Discount Codes",
          href: `/trusts/${trustId}/discount-codes`,
        },
        {
          title: "Processing Fees",
          href: `/trusts/${trustId}/processing-fees`,
        },
        {
          title: "Buyer's Premium",
          href: `/trusts/${trustId}/trust-general-settings?tab=trust`,
        },
      ],
    },
  ];

  const bankingMenu = [
    {
      title: "Trust Banking",
      href: `/trusts/${trustId}/banking`,
      description: "Trust Banking",
    },
    {
      title: "Payment Instructions",
      href: `/trusts/${trustId}/abas`,
      description: "Payment Instructions",
    },
  ];

  // eslint-disable-next-line no-unused-vars
  const reportMenu = [
    {
      title: "Cashbook",
      href: !trustId
        ? "/cashbook-report"
        : `/trusts/${trustId}/cashbook-report`,
      description: "Cashbook Report",
    },
    {
      title: "General Ledger",
      href: !trustId
        ? "/general-ledger-report"
        : `/trusts/${trustId}/general-ledger-report`,
      description: "General Ledger Report",
    },
    {
      title: "Trial Balance",
      href: !trustId
        ? "/trial-balance-report"
        : `/trusts/${trustId}/trial-balance-report`,
      description: "Trial Balance Report",
    },
    {
      title: "Monthly Bank Reconciliation",
      href: !trustId
        ? "/banking?tab=monthly-bank-reconciliation"
        : `/trusts/${trustId}/banking?tab=monthly-bank-reconciliation`,
      description: "Monthly Bank Reconciliation",
    },
    {
      title: "Statement Report",
      href: !trustId
        ? "/statement-report"
        : `/trusts/${trustId}/statement-report`,
      description: "Statement Report",
    },
    // {
    //   title: "Financial Report",
    //   href: !trustId
    //     ? "/financial-report"
    //     : `/trusts/${trustId}/financial-report`,
    //   description: "Financial Report",
    // },
  ];

  const contactMenu = [
    {
      title: getModuleNamingBySlug(
        organizationData?.organizationData,
        "vendors",
        "Vendor",
      ),
      href: `/trusts/${trustId}/vendors`,
      description: "Vendors",
    },
    {
      title: getModuleNamingBySlug(
        organizationData?.organizationData,
        "contacts",
        "Customer",
      ),
      href: `/trusts/${trustId}/contacts`,
      description: "Contacts",
    },
    {
      title: "Suppliers",
      href: `/trusts/${trustId}/suppliers`,
      description: "Suppliers",
    },
    {
      title: "Beneficiaries",
      href: `/trusts/${trustId}/beneficiaries`,
      description: "Beneficiaries",
    },
    {
      title: "Joint Accounts",
      href: `/trusts/${trustId}/joint-accounts`,
      description: "Joint Accounts",
    },
  ];

  const orgContactMenu = [
    {
      title: getModuleNamingBySlug(
        organizationData?.organizationData,
        "vendors",
        "Vendor",
      ),
      href: `/vendors`,
      description: "Vendors",
    },
    {
      title: getModuleNamingBySlug(
        organizationData?.organizationData,
        "contacts",
        "Customer",
      ),
      href: `/contacts`,
      description: "Contacts",
    },

    {
      title: "Beneficiaries",
      href: `/beneficiaries`,
      description: "Beneficiaries",
    },
    {
      title: "Joint Accounts",
      href: `/joint-accounts`,
      description: "Joint Accounts",
    },
  ];

  let amlCTFEnable =
    (userData?.email === "dchoradiya@gmail.com" ||
      organizationData?.organizationData?.is_aml_ctf_subscribed) &&
    AMLCTFModuleConditonIndustry(organizationData)
      ? true
      : false;

  return (
    <div className="relative">
      <header className="flex h-16 items-center gap-4 border-b bg-background px-4 z-[10] text-secondary-foreground">
        <div className="hidden flex-col gap-2 text-lg font-medium xl:flex xl:flex-row xl:items-center xl:text-sm">
          {trigger && trigger}
          <NavigationMenu>
            {roleType === "Admin" ? (
              <NavigationMenuList>
                <NavigationMenuItem>
                  <Link to={`/admin-dashboard`}>
                    <NavigationMenuLink
                      className={navigationMenuTriggerStyle()}
                      active={pathname?.includes("/admin-dashboard")}
                    >
                      Dashboard
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to={`/registered-users`}>
                    <NavigationMenuLink
                      className={navigationMenuTriggerStyle()}
                      active={pathname?.includes("/registered-users")}
                    >
                      Registered Users
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to={`/admin-roles`}>
                    <NavigationMenuLink
                      className={navigationMenuTriggerStyle()}
                      active={pathname?.includes("/admin-roles")}
                    >
                      Roles
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to={`/admin-users`}>
                    <NavigationMenuLink
                      className={navigationMenuTriggerStyle()}
                      active={pathname?.includes("/admin-users")}
                    >
                      Users
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to={`/admin/states`}>
                    <NavigationMenuLink
                      className={navigationMenuTriggerStyle()}
                      active={pathname?.includes("/admin/states")}
                    >
                      States
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to={`/admin/suburbs`}>
                    <NavigationMenuLink
                      className={navigationMenuTriggerStyle()}
                      active={pathname?.includes("/admin/suburbs")}
                    >
                      Suburbs
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to={`/admin/support-tickets`}>
                    <NavigationMenuLink
                      className={navigationMenuTriggerStyle()}
                      active={pathname?.includes("/admin/support-tickets")}
                    >
                      Support Tickets
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to={`/admin/aml-ctf`}>
                    <NavigationMenuLink
                      className={navigationMenuTriggerStyle()}
                      active={pathname?.includes("/admin/aml-ctf")}
                    >
                      AML/CTF
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to={`/admin/module-namings`}>
                    <NavigationMenuLink
                      className={navigationMenuTriggerStyle()}
                      active={pathname?.includes("/admin/module-namings")}
                    >
                      Module Naming
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to={`/admin/faqs`}>
                    <NavigationMenuLink
                      className={navigationMenuTriggerStyle()}
                      active={pathname?.includes("/admin/faqs")}
                    >
                      FAQs
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
                {/* <NavigationMenuItem>
                  <Link to={`/modules`}>
                    <NavigationMenuLink
                      className={navigationMenuTriggerStyle()}
                      active={pathname?.includes("/modules")}
                    >
                      Modules
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem> */}
              </NavigationMenuList>
            ) : trustId ? (
              <NavigationMenuList>
                <NavigationMenuItem>
                  <OrganizationSwitcher />
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <TrustSwitcher />
                </NavigationMenuItem>
                {/* <NavigationMenuItem>
                  <Link to="/trusts">
                    <NavigationMenuLink
                      className={navigationMenuTriggerStyle()}
                      active={"/trusts" === pathname}
                    >
                      Trust
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem> */}

                <NavigationMenuItem>
                  <Link to={`/trusts/${trustId}/dashboard`}>
                    <NavigationMenuLink
                      className={navigationMenuTriggerStyle()}
                      active={pathname?.includes("/dashboard")}
                    >
                      Dashboard
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to="/trusts">
                    <NavigationMenuLink
                      className={cn(navigationMenuTriggerStyle())}
                      active={"/trusts" === pathname}
                    >
                      Trusts
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <div className="relative">
                    {" "}
                    <NavigationMenuTrigger
                      data-state={
                        (pathname?.includes("/assets") ||
                          pathname?.includes("/sub-assets") ||
                          pathname?.includes("/contracts") ||
                          pathname?.includes("/jobs") ||
                          pathname?.includes("/tasks")) &&
                        "open"
                      }
                    >
                      {LawyerConditon(organizationData)
                        ? "Matter Hub"
                        : "Asset Hub"}
                    </NavigationMenuTrigger>
                    <NavigationMenuContent>
                      <ul className="grid w-full gap-1 p-1 max-w-[500px]">
                        {assetManagementMenu.map((item) => (
                          <ListItem
                            key={item.title}
                            title={item.title}
                            href={item.href}
                            active={item.href === pathname ? true : false}
                            className="px-2 py-1.5 whitespace-nowrap"
                          >
                            {/* {item.description} */}
                          </ListItem>
                        ))}
                      </ul>
                    </NavigationMenuContent>
                  </div>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <div className="relative">
                    {" "}
                    <NavigationMenuTrigger
                      data-state={
                        (pathname?.includes("/vendors") ||
                          pathname?.includes("/contacts") ||
                          pathname?.includes("/suppliers") ||
                          pathname?.includes("/beneficiaries") ||
                          pathname?.includes("/joint-accounts")) &&
                        "open"
                      }
                    >
                      Contact Hub
                    </NavigationMenuTrigger>
                    <NavigationMenuContent>
                      <ul className="grid w-full gap-1 p-1 max-w-[500px]">
                        {contactMenu.map((item) => (
                          <ListItem
                            key={item.title}
                            title={item.title}
                            href={item.href}
                            active={item.href === pathname ? true : false}
                            className="px-2 py-1.5 whitespace-nowrap"
                          >
                            {/* {item.description} */}
                          </ListItem>
                        ))}
                      </ul>
                    </NavigationMenuContent>
                  </div>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <div className="relative">
                    {" "}
                    <NavigationMenuTrigger
                      data-state={
                        (pathname?.includes("/journal-entries") ||
                          pathname?.includes("/chart-of-accounts") ||
                          pathname?.includes("/receipts") ||
                          pathname?.includes("/payments")) &&
                        "open"
                      }
                    >
                      Accounting
                    </NavigationMenuTrigger>
                    <NavigationMenuContent>
                      <ul className="grid w-full gap-1 p-1 max-w-[500px]">
                        {accountingMenu.map((item) => (
                          <ListItem
                            key={item.title}
                            title={item.title}
                            href={item.href}
                            active={item.href === pathname ? true : false}
                            className="px-2 py-1.5 whitespace-nowrap"
                          >
                            {/* {item.description} */}
                          </ListItem>
                        ))}
                      </ul>
                    </NavigationMenuContent>
                  </div>
                </NavigationMenuItem>
                {InvoiceModuleConditon(organizationData) && (
                  // <NavigationMenuItem>
                  //   <div className="relative">
                  //     {" "}
                  //     <NavigationMenuTrigger
                  //       data-state={
                  //         (pathname?.includes("/processing-fees") ||
                  //           pathname?.includes("/discount-codes") ||
                  //           pathname?.includes("/invoices")) &&
                  //         "open"
                  //       }
                  //     >
                  //       Invoicing
                  //     </NavigationMenuTrigger>
                  //     <NavigationMenuContent>
                  //       <ul className="grid w-full gap-1 p-1 max-w-[500px]">
                  //         {invoicingMenu.map((item) => (
                  //           <ListItem
                  //             key={item.title}
                  //             title={item.title}
                  //             href={item.href}
                  //             active={item.href === pathname ? true : false}
                  //             className="px-2 py-1.5 whitespace-nowrap"
                  //           >
                  //           </ListItem>
                  //         ))}
                  //       </ul>
                  //     </NavigationMenuContent>
                  //   </div>
                  // </NavigationMenuItem>

                  <NavigationMenuItem>
                    <div className="relative">
                      <NavigationMenuTrigger
                        data-state={
                          pathname?.includes("/processing-fees") ||
                          pathname?.includes("/discount-codes") ||
                          pathname?.includes("/invoices")
                            ? "open"
                            : "closed"
                        }
                      >
                        Invoicing
                      </NavigationMenuTrigger>

                      <NavigationMenuContent>
                        <ul className="grid w-full gap-2 p-2 max-w-[400px]">
                          {invoicingMenu.map((item) => {
                            if (item.children) {
                              // ✅ Nested submenu (Invoice Tools)
                              return (
                                <Collapsible
                                  key={item.title}
                                  open={openInvoiceSubMenu}
                                  onOpenChange={setOpenInvoiceSubMenu}
                                  onMouseEnter={() =>
                                    setOpenInvoiceSubMenu(true)
                                  }
                                  onMouseLeave={() =>
                                    setOpenInvoiceSubMenu(false)
                                  }
                                  className="group"
                                >
                                  <CollapsibleTrigger asChild>
                                    <div className="flex cursor-pointer items-center justify-between px-2 py-1.5 rounded hover:bg-accent hover:text-accent-foreground whitespace-nowrap min-w-[150px]">
                                      <span>{item.title}</span>
                                      <ChevronRight className="ml-1 h-3 w-3 transition-transform duration-200 group-data-[state=open]:rotate-90" />
                                    </div>
                                  </CollapsibleTrigger>

                                  <CollapsibleContent className="ml-4 mt-1 space-y-1">
                                    {item.children.map((child) => (
                                      <ListItem
                                        key={child.title}
                                        title={child.title}
                                        href={child.href}
                                        active={child.href === pathname}
                                        className="px-2 py-1.5 whitespace-nowrap"
                                      />
                                    ))}
                                  </CollapsibleContent>
                                </Collapsible>
                              );
                            }

                            // ✅ Regular menu item (Invoices)
                            return (
                              <ListItem
                                key={item.title}
                                title={item.title}
                                href={item.href}
                                active={item.href === pathname}
                                className="px-2 py-1.5 whitespace-nowrap"
                              />
                            );
                          })}
                        </ul>
                      </NavigationMenuContent>
                    </div>
                  </NavigationMenuItem>
                )}

                <NavigationMenuItem>
                  <div className="relative">
                    {" "}
                    <NavigationMenuTrigger
                      data-state={
                        (pathname?.includes("/cashbook-report") ||
                          pathname?.includes("/statement-report") ||
                          pathname?.includes("/general-ledger-report") ||
                          pathname?.includes("/trial-balance-report") ||
                          pathname?.includes("/financial-report") ||
                          window.location.search?.includes(
                            "tab=monthly-bank-reconciliation",
                          )) &&
                        "open"
                      }
                    >
                      Reports
                    </NavigationMenuTrigger>
                    <NavigationMenuContent>
                      <ul className="grid w-full gap-1 p-1 max-w-[500px]">
                        {reportMenu.map((item) => (
                          <ListItem
                            key={item.title}
                            title={item.title}
                            href={item.href}
                            active={
                              item.href === pathname ||
                              (window.location.search.includes(
                                "tab=monthly-bank-reconciliation",
                              ) &&
                                item.href.includes(
                                  "tab=monthly-bank-reconciliation",
                                ))
                                ? true
                                : false
                            }
                            className="px-2 py-1.5 whitespace-nowrap"
                          ></ListItem>
                        ))}
                      </ul>
                    </NavigationMenuContent>
                  </div>
                </NavigationMenuItem>

                {/* <NavigationMenuItem>
                  <Link to={`/trusts/${trustId}/banking`}>
                    <NavigationMenuLink
                      className={`p-0 ${navigationMenuTriggerStyle()}`}
                      active={
                        pathname?.includes("/banking") &&
                        !window.location.search?.includes(
                          "tab=monthly-bank-reconciliation"
                        )
                      }
                    >
                      Banking
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to={`/trusts/${trustId}/payments`}>
                    <NavigationMenuLink
                      className={`p-0 ${navigationMenuTriggerStyle()}`}
                      active={pathname?.includes("/payments")}
                    >
                      Payments
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to={`/trusts/${trustId}/receipts`}>
                    <NavigationMenuLink
                      className={`p-0 ${navigationMenuTriggerStyle()}`}
                      active={pathname?.includes("/receipts")}
                    >
                      Receipts
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem> */}
                <NavigationMenuItem>
                  <div className="relative">
                    {" "}
                    <NavigationMenuTrigger
                      data-state={
                        (pathname?.includes("/banking") ||
                          pathname?.includes("/abas")) &&
                        "open"
                      }
                    >
                      Banking
                    </NavigationMenuTrigger>
                    <NavigationMenuContent>
                      <ul className="grid w-full gap-1 p-1 max-w-[500px]">
                        {bankingMenu.map((item) => (
                          <ListItem
                            key={item.title}
                            title={item.title}
                            href={item.href}
                            active={item.href === pathname ? true : false}
                            className="px-2 py-1.5 whitespace-nowrap"
                          >
                            {/* {item.description} */}
                          </ListItem>
                        ))}
                      </ul>
                    </NavigationMenuContent>
                  </div>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <div className="relative">
                    {" "}
                    <NavigationMenuTrigger
                      data-state={
                        (pathname?.includes("/users") ||
                          pathname?.includes("/offices") ||
                          pathname?.includes("/general-settings")) &&
                        "open"
                      }
                    >
                      Settings
                    </NavigationMenuTrigger>
                    <NavigationMenuContent>
                      <ul className="grid w-full gap-1 p-1 max-w-[500px]">
                        {settingsMenu.map((item) => (
                          <ListItem
                            key={item.title}
                            title={item.title}
                            href={item.href}
                            active={item.href === pathname ? true : false}
                            className="px-2 py-1.5 whitespace-nowrap"
                          >
                            {/* {item.description} */}
                          </ListItem>
                        ))}
                      </ul>
                    </NavigationMenuContent>
                  </div>
                </NavigationMenuItem>
              </NavigationMenuList>
            ) : (
              <NavigationMenuList>
                <NavigationMenuItem>
                  <OrganizationSwitcher />
                </NavigationMenuItem>
                {organizationData?.organizationData?.is_subscribed ? (
                  <NavigationMenuItem>
                    <Link to="/trusts">
                      <NavigationMenuLink
                        className={navigationMenuTriggerStyle()}
                        active={"/trusts" === pathname}
                      >
                        Trusts
                      </NavigationMenuLink>
                    </Link>
                  </NavigationMenuItem>
                ) : (
                  ""
                )}
                {/* <NavigationMenuItem>
                  <Link to="/general-settings?tab=subscription">
                    <NavigationMenuLink
                      className={navigationMenuTriggerStyle()}
                      active={window.location.search === "?tab=subscription"}
                    >
                      Subscription
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem> */}

                {amlCTFEnable && (
                  <NavigationMenuItem>
                    <div className="relative">
                      {" "}
                      <NavigationMenuTrigger
                        data-state={
                          (pathname?.includes("/vendors") ||
                            pathname?.includes("/contacts") ||
                            pathname?.includes("/beneficiaries") ||
                            pathname?.includes("/joint-accounts")) &&
                          "open"
                        }
                      >
                        Contact Hub
                      </NavigationMenuTrigger>
                      <NavigationMenuContent>
                        <ul className="grid w-full gap-1 p-1 max-w-[500px]">
                          {orgContactMenu.map((item) => (
                            <ListItem
                              key={item.title}
                              title={item.title}
                              href={item.href}
                              active={item.href === pathname ? true : false}
                              className="px-2 py-1.5 whitespace-nowrap"
                            >
                              {/* {item.description} */}
                            </ListItem>
                          ))}
                        </ul>
                      </NavigationMenuContent>
                    </div>
                  </NavigationMenuItem>
                )}

                {organizationData?.organizationData?.is_subscribed ? (
                  <NavigationMenuItem>
                    <div className="relative">
                      {" "}
                      <NavigationMenuTrigger
                        data-state={
                          (pathname?.includes("/cashbook-report") ||
                            pathname?.includes("/statement-report") ||
                            pathname?.includes("/general-ledger-report") ||
                            pathname?.includes("/trial-balance-report") ||
                            pathname?.includes("/financial-report") ||
                            window.location.search?.includes(
                              "tab=monthly-bank-reconciliation",
                            )) &&
                          "open"
                        }
                      >
                        Reports
                      </NavigationMenuTrigger>
                      <NavigationMenuContent>
                        <ul className="grid w-full gap-1 p-1 max-w-[500px]">
                          {reportMenu.map((item) => (
                            <ListItem
                              key={item.title}
                              title={item.title}
                              href={item.href}
                              active={
                                item.href === pathname ||
                                (window.location.search.includes(
                                  "tab=monthly-bank-reconciliation",
                                ) &&
                                  item.href.includes(
                                    "tab=monthly-bank-reconciliation",
                                  ))
                                  ? true
                                  : false
                              }
                              className="px-2 py-1.5 whitespace-nowrap"
                            ></ListItem>
                          ))}
                        </ul>
                      </NavigationMenuContent>
                    </div>
                  </NavigationMenuItem>
                ) : (
                  <></>
                )}

                <NavigationMenuItem>
                  <div className="relative">
                    {" "}
                    <NavigationMenuTrigger
                      data-state={
                        (pathname?.includes("/users") ||
                          pathname?.includes("/offices") ||
                          pathname?.includes("/general-settings")) &&
                        "open"
                      }
                    >
                      Settings
                    </NavigationMenuTrigger>
                    <NavigationMenuContent>
                      <ul className="grid w-full gap-1 p-1 max-w-[500px]">
                        {settingsMenu.map((item) => (
                          <ListItem
                            key={item.title}
                            title={item.title}
                            href={item.href}
                            active={item.href === pathname ? true : false}
                            className="px-2 py-1.5 whitespace-nowrap"
                          >
                            {/* {item.description} */}
                          </ListItem>
                        ))}
                      </ul>
                    </NavigationMenuContent>
                  </div>
                </NavigationMenuItem>

                {amlCTFEnable && (
                  <NavigationMenuItem>
                    <Link to="/aml-ctf">
                      <NavigationMenuLink
                        className={navigationMenuTriggerStyle()}
                        active={"/aml-ctf" === pathname}
                      >
                        AML/CTF
                      </NavigationMenuLink>
                    </Link>
                  </NavigationMenuItem>
                )}
              </NavigationMenuList>
            )}
          </NavigationMenu>
        </div>
        <div className="xl:hidden ">{trigger}</div>
        <Sheet>
          <SheetTrigger asChild>
            <Button
              variant="outline"
              size="icon"
              className="shrink-0 xl:hidden w-auto h-10"
            >
              <div className="flex items-center gap-2 p-2">
                {/* <div className="flex items-center gap-1">
                  <LogoSVG className="group-data-[state=collapsed]:hidden !text-webPrimary !fill-webPrimary h-9 w-full" />
                </div> */}
                <Menu className="h-5 w-5" />
              </div>
              <span className="sr-only">Toggle navigation menu</span>
            </Button>
          </SheetTrigger>
          <SheetContent
            side="left"
            className="md:max-w-fit w-fit pl-1 pr-10 pt-2"
          >
            <nav className="grid gap-4 text-lg font-medium">
              <Link to="/" className="">
                <LogoSVG className="pl-2 group-data-[state=collapsed]:hidden !text-webPrimary !fill-webPrimary h-16" />
              </Link>
              <NavigationMenu>
                {roleType === "Admin" ? (
                  <NavigationMenuList className="flex-col gap-2 items-baseline">
                    <NavigationMenuItem>
                      <Link to={`/admin-dashboard`}>
                        <NavigationMenuLink
                          className={navigationMenuTriggerStyle()}
                          active={pathname?.includes("/admin-dashboard")}
                        >
                          Dashboard
                        </NavigationMenuLink>
                      </Link>
                    </NavigationMenuItem>
                    <NavigationMenuItem>
                      <Link to={`/registered-users`}>
                        <NavigationMenuLink
                          className={navigationMenuTriggerStyle()}
                          active={pathname?.includes("/registered-users")}
                        >
                          Registered Users
                        </NavigationMenuLink>
                      </Link>
                    </NavigationMenuItem>
                    <NavigationMenuItem>
                      <Link to={`/admin-roles`}>
                        <NavigationMenuLink
                          className={navigationMenuTriggerStyle()}
                          active={pathname?.includes("/admin-roles")}
                        >
                          Roles
                        </NavigationMenuLink>
                      </Link>
                    </NavigationMenuItem>
                    <NavigationMenuItem>
                      <Link to={`/admin-users`}>
                        <NavigationMenuLink
                          className={navigationMenuTriggerStyle()}
                          active={pathname?.includes("/admin-users")}
                        >
                          Users
                        </NavigationMenuLink>
                      </Link>
                    </NavigationMenuItem>
                    <NavigationMenuItem>
                      <Link to={`/admin/states`}>
                        <NavigationMenuLink
                          className={navigationMenuTriggerStyle()}
                          active={pathname?.includes("/admin/states")}
                        >
                          States
                        </NavigationMenuLink>
                      </Link>
                    </NavigationMenuItem>
                    <NavigationMenuItem>
                      <Link to={`/admin/suburbs`}>
                        <NavigationMenuLink
                          className={navigationMenuTriggerStyle()}
                          active={pathname?.includes("/admin/suburbs")}
                        >
                          Suburbs
                        </NavigationMenuLink>
                      </Link>
                    </NavigationMenuItem>
                    <NavigationMenuItem>
                      <Link to={`/admin/support-tickets`}>
                        <NavigationMenuLink
                          className={navigationMenuTriggerStyle()}
                          active={pathname?.includes("/admin/support-tickets")}
                        >
                          Support Tickets
                        </NavigationMenuLink>
                      </Link>
                    </NavigationMenuItem>
                    <NavigationMenuItem>
                      <Link to={`/admin/aml-ctf`}>
                        <NavigationMenuLink
                          className={navigationMenuTriggerStyle()}
                          active={pathname?.includes("/admin/aml-ctf")}
                        >
                          AML/CTF
                        </NavigationMenuLink>
                      </Link>
                    </NavigationMenuItem>
                    <NavigationMenuItem>
                      <Link to={`/admin/module-namings`}>
                        <NavigationMenuLink
                          className={navigationMenuTriggerStyle()}
                          active={pathname?.includes("/admin/module-namings")}
                        >
                          Module Naming
                        </NavigationMenuLink>
                      </Link>
                    </NavigationMenuItem>
                    <NavigationMenuItem>
                      <Link to={`/admin/faqs`}>
                        <NavigationMenuLink
                          className={navigationMenuTriggerStyle()}
                          active={pathname?.includes("/admin/faqs")}
                        >
                          FAQs
                        </NavigationMenuLink>
                      </Link>
                    </NavigationMenuItem>
                  </NavigationMenuList>
                ) : trustId ? (
                  <NavigationMenuList className="flex-col gap-2 items-baseline">
                    <NavigationMenuItem>
                      <OrganizationSwitcher mobileMenu={true} />
                    </NavigationMenuItem>
                    {
                      /* <NavigationMenuItem>
                      <Link to="/trusts">
                        <NavigationMenuLink
                          className={cn(
                            navigationMenuTriggerStyle(),
                            "w-[246px] justify-start"
                          )}
                          active={"/trusts" === pathname}
                        >
                          Trust
                        </NavigationMenuLink>
                      </Link>
                    </NavigationMenuItem> */
                      <NavigationMenuItem className="flex-col gap-2 items-baseline">
                        <TrustSwitcher mobileMenu={true} />
                      </NavigationMenuItem>
                    }
                    <NavigationMenuItem>
                      <Link to={`/trusts/${trustId}/dashboard`}>
                        <NavigationMenuLink
                          className={cn(
                            navigationMenuTriggerStyle(),
                            "w-[246px] justify-start",
                          )}
                          active={pathname?.includes("/dashboard")}
                        >
                          Dashboard
                        </NavigationMenuLink>
                      </Link>
                    </NavigationMenuItem>
                    <NavigationMenuItem>
                      <Link to="/trusts">
                        <NavigationMenuLink
                          className={cn(
                            navigationMenuTriggerStyle(),
                            "w-[246px] justify-start",
                          )}
                          active={"/trusts" === pathname}
                        >
                          Trusts
                        </NavigationMenuLink>
                      </Link>
                    </NavigationMenuItem>
                    <Collapsible
                      asChild
                      defaultOpen={
                        pathname?.includes("/assets") ||
                        pathname?.includes("/sub-assets") ||
                        pathname?.includes("/contracts") ||
                        pathname?.includes("/jobs") ||
                        pathname?.includes("/tasks")
                          ? true
                          : false
                      }
                      className="group/collapsible"
                    >
                      <NavigationMenuItem>
                        <CollapsibleTrigger asChild>
                          <NavigationMenuLink
                            className={cn(
                              navigationMenuTriggerStyle(),
                              "w-[246px] justify-between",
                            )}
                          >
                            <span>
                              {LawyerConditon(organizationData)
                                ? "Matter Hub"
                                : "Asset Hub"}
                            </span>
                            <ChevronRight className="ml-1 h-3 w-3 transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                          </NavigationMenuLink>
                        </CollapsibleTrigger>
                        <CollapsibleContent>
                          <SidebarMenuSub className="mt-2">
                            {assetManagementMenu?.map((item) => (
                              <ListItem
                                key={item.title}
                                title={item.title}
                                href={item.href}
                                active={item.href === pathname ? true : false}
                                className="px-2 py-1.5 whitespace-nowrap"
                              />
                            ))}
                          </SidebarMenuSub>
                        </CollapsibleContent>
                      </NavigationMenuItem>
                    </Collapsible>

                    <Collapsible
                      asChild
                      defaultOpen={
                        pathname?.includes("/vendors") ||
                        pathname?.includes("/contacts") ||
                        pathname?.includes("/suppliers") ||
                        pathname?.includes("/beneficiaries") ||
                        pathname?.includes("/joint-accounts")
                          ? true
                          : false
                      }
                      className="group/collapsible"
                    >
                      <NavigationMenuItem>
                        <CollapsibleTrigger asChild>
                          <NavigationMenuLink
                            className={cn(
                              navigationMenuTriggerStyle(),
                              "w-[246px] justify-between",
                            )}
                          >
                            <span>{"Contact Hub"}</span>
                            <ChevronRight className="ml-1 h-3 w-3 transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                          </NavigationMenuLink>
                        </CollapsibleTrigger>
                        <CollapsibleContent>
                          <SidebarMenuSub className="mt-2">
                            {contactMenu?.map((item) => (
                              <ListItem
                                key={item.title}
                                title={item.title}
                                href={item.href}
                                active={item.href === pathname ? true : false}
                                className="px-2 py-1.5 whitespace-nowrap"
                              />
                            ))}
                          </SidebarMenuSub>
                        </CollapsibleContent>
                      </NavigationMenuItem>
                    </Collapsible>

                    <Collapsible
                      asChild
                      defaultOpen={
                        pathname?.includes("/journal-entries") ||
                        pathname?.includes("/chart-of-accounts") ||
                        pathname?.includes("/receipts") ||
                        pathname?.includes("/payments")
                          ? true
                          : false
                      }
                      className="group/collapsible"
                    >
                      <NavigationMenuItem>
                        <CollapsibleTrigger asChild>
                          <NavigationMenuLink
                            className={cn(
                              navigationMenuTriggerStyle(),
                              "w-[246px] justify-between",
                            )}
                          >
                            <span>{"Accounting"}</span>
                            <ChevronRight className="ml-1 h-3 w-3 transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                          </NavigationMenuLink>
                        </CollapsibleTrigger>
                        <CollapsibleContent>
                          <SidebarMenuSub className="mt-2">
                            {accountingMenu?.map((item) => (
                              <ListItem
                                key={item.title}
                                title={item.title}
                                href={item.href}
                                active={item.href === pathname ? true : false}
                                className="px-2 py-1.5 whitespace-nowrap"
                              />
                            ))}
                          </SidebarMenuSub>
                        </CollapsibleContent>
                      </NavigationMenuItem>
                    </Collapsible>

                    {InvoiceModuleConditon(organizationData) && (
                      // <Collapsible
                      //   asChild
                      //   defaultOpen={
                      //     pathname?.includes("/processing-fees") ||
                      //     pathname?.includes("/discount-codes") ||
                      //     pathname?.includes("/invoices")
                      //       ? true
                      //       : false
                      //   }
                      //   className="group/collapsible"
                      // >
                      //   <NavigationMenuItem>
                      //     <CollapsibleTrigger asChild>
                      //       <NavigationMenuLink
                      //         className={cn(
                      //           navigationMenuTriggerStyle(),
                      //           "w-[246px] justify-between"
                      //         )}
                      //       >
                      //         <span>{"Invoicing"}</span>
                      //         <ChevronRight className="ml-1 h-3 w-3 transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                      //       </NavigationMenuLink>
                      //     </CollapsibleTrigger>
                      //     <CollapsibleContent>
                      //       <SidebarMenuSub className="mt-2">
                      //         {invoicingMenu?.map((item) => (
                      //           <ListItem
                      //             key={item.title}
                      //             title={item.title}
                      //             href={item.href}
                      //             active={item.href === pathname ? true : false}
                      //             className="px-2 py-1.5 whitespace-nowrap"
                      //           />
                      //         ))}
                      //       </SidebarMenuSub>
                      //     </CollapsibleContent>
                      //   </NavigationMenuItem>
                      // </Collapsible>
                      <Collapsible
                        asChild
                        defaultOpen={
                          pathname?.includes("/processing-fees") ||
                          pathname?.includes("/discount-codes") ||
                          pathname?.includes("/invoices")
                        }
                        className="group/collapsible"
                      >
                        <NavigationMenuItem>
                          {/* Invoicing trigger */}
                          <CollapsibleTrigger asChild>
                            <NavigationMenuLink
                              className={cn(
                                navigationMenuTriggerStyle(),
                                "w-[246px] justify-between cursor-pointer",
                              )}
                            >
                              <span>Invoicing</span>
                              <ChevronRight className="ml-1 h-3 w-3 transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                            </NavigationMenuLink>
                          </CollapsibleTrigger>

                          {/* Invoicing submenu */}
                          <CollapsibleContent>
                            <SidebarMenuSub className="mt-2 space-y-1">
                              {invoicingMenu.map((item) =>
                                item.children ? (
                                  // Nested collapsible for Invoice Tools
                                  <Collapsible
                                    key={item.title}
                                    className="group/nested-collapsible"
                                  >
                                    <CollapsibleTrigger asChild>
                                      <div
                                        className={cn(
                                          "flex cursor-pointer items-center justify-between px-2 py-1.5 text-sm rounded-md hover:bg-accent",
                                        )}
                                      >
                                        <span>{item.title}</span>
                                        <ChevronRight className="ml-1 h-3 w-3 transition-transform duration-200 group-data-[state=open]/nested-collapsible:rotate-90" />
                                      </div>
                                    </CollapsibleTrigger>
                                    <CollapsibleContent>
                                      <div className="ml-4 mt-1 space-y-1">
                                        {item.children.map((child) => (
                                          <ListItem
                                            key={child.title}
                                            title={child.title}
                                            href={child.href}
                                            active={child.href === pathname}
                                            className="px-2 py-1.5 whitespace-nowrap"
                                          />
                                        ))}
                                      </div>
                                    </CollapsibleContent>
                                  </Collapsible>
                                ) : (
                                  <ListItem
                                    key={item.title}
                                    title={item.title}
                                    href={item.href}
                                    active={item.href === pathname}
                                    className="px-2 py-1.5 whitespace-nowrap"
                                  />
                                ),
                              )}
                            </SidebarMenuSub>
                          </CollapsibleContent>
                        </NavigationMenuItem>
                      </Collapsible>
                    )}

                    <Collapsible
                      asChild
                      defaultOpen={
                        pathname?.includes("/cashbook-report") ||
                        pathname?.includes("/statement-report") ||
                        pathname?.includes("/general-ledger-report") ||
                        pathname?.includes("/trial-balance-report") ||
                        pathname?.includes("/financial-report") ||
                        window.location.search?.includes(
                          "tab=monthly-bank-reconciliation",
                        )
                          ? true
                          : false
                      }
                      className="group/collapsible"
                    >
                      <NavigationMenuItem>
                        <CollapsibleTrigger asChild>
                          <NavigationMenuLink
                            className={cn(
                              navigationMenuTriggerStyle(),
                              "w-[246px] justify-between",
                            )}
                          >
                            <span>{"Reports"}</span>
                            <ChevronRight className="ml-1 h-3 w-3 transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                          </NavigationMenuLink>
                        </CollapsibleTrigger>
                        <CollapsibleContent>
                          <SidebarMenuSub className="mt-2">
                            {reportMenu?.map((item) => (
                              <ListItem
                                key={item.title}
                                title={item.title}
                                href={item.href}
                                active={item.href === pathname ? true : false}
                                className="px-2 py-1.5 whitespace-nowrap"
                              />
                            ))}
                          </SidebarMenuSub>
                        </CollapsibleContent>
                      </NavigationMenuItem>
                    </Collapsible>

                    {/* <NavigationMenuItem>
                      <Link to={`/trusts/${trustId}/banking`}>
                        <NavigationMenuLink
                          className={cn(
                            navigationMenuTriggerStyle(),
                            "w-[246px] justify-start"
                          )}
                          active={
                            pathname?.includes("/banking") &&
                            !window.location.search?.includes(
                              "tab=monthly-bank-reconciliation"
                            )
                          }
                        >
                          Banking
                        </NavigationMenuLink>
                      </Link>
                    </NavigationMenuItem>
                    <NavigationMenuItem>
                      <Link to={`/trusts/${trustId}/payments`}>
                        <NavigationMenuLink
                          className={cn(
                            navigationMenuTriggerStyle(),
                            "w-[246px] justify-start"
                          )}
                          active={pathname?.includes("/payments")}
                        >
                          Payments
                        </NavigationMenuLink>
                      </Link>
                    </NavigationMenuItem>

                    <NavigationMenuItem>
                      <Link to={`/trusts/${trustId}/receipts`}>
                        <NavigationMenuLink
                          className={cn(
                            navigationMenuTriggerStyle(),
                            "w-[246px] justify-start"
                          )}
                          active={pathname?.includes("/receipts")}
                        >
                          Receipts
                        </NavigationMenuLink>
                      </Link>
                    </NavigationMenuItem> */}

                    <Collapsible
                      asChild
                      defaultOpen={
                        pathname?.includes("/banking") ||
                        pathname?.includes("/abas")
                          ? true
                          : false
                      }
                      className="group/collapsible"
                    >
                      <NavigationMenuItem>
                        <CollapsibleTrigger asChild>
                          <NavigationMenuLink
                            className={cn(
                              navigationMenuTriggerStyle(),
                              "w-[246px] justify-between",
                            )}
                          >
                            <span>{"Banking"}</span>
                            <ChevronRight className="ml-1 h-3 w-3 transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                          </NavigationMenuLink>
                        </CollapsibleTrigger>
                        <CollapsibleContent>
                          <SidebarMenuSub className="mt-2">
                            {bankingMenu.map((item) => (
                              <ListItem
                                key={item.title}
                                title={item.title}
                                href={item.href}
                                active={item.href === pathname ? true : false}
                                className="px-2 py-1.5 whitespace-nowrap"
                              >
                                {/* {item.description} */}
                              </ListItem>
                            ))}
                          </SidebarMenuSub>
                        </CollapsibleContent>
                      </NavigationMenuItem>
                    </Collapsible>

                    <Collapsible
                      asChild
                      defaultOpen={
                        pathname?.includes("/users") ||
                        pathname?.includes("/offices") ||
                        pathname?.includes("/general-settings") ||
                        pathname?.includes("/opening-balances")
                          ? true
                          : false
                      }
                      className="group/collapsible"
                    >
                      <NavigationMenuItem>
                        <CollapsibleTrigger asChild>
                          <NavigationMenuLink
                            className={cn(
                              navigationMenuTriggerStyle(),
                              "w-[246px] justify-between",
                            )}
                          >
                            <span>{"Settings"}</span>
                            <ChevronRight className="ml-1 h-3 w-3 transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                          </NavigationMenuLink>
                        </CollapsibleTrigger>
                        <CollapsibleContent>
                          <SidebarMenuSub className="mt-2">
                            {settingsMenu?.map((item) => (
                              <ListItem
                                key={item.title}
                                title={item.title}
                                href={item.href}
                                active={item.href === pathname ? true : false}
                                className="px-2 py-1.5 whitespace-nowrap"
                              />
                            ))}
                          </SidebarMenuSub>
                        </CollapsibleContent>
                      </NavigationMenuItem>
                    </Collapsible>
                  </NavigationMenuList>
                ) : (
                  <NavigationMenuList className="flex-col gap-2 items-baseline">
                    <NavigationMenuItem>
                      <OrganizationSwitcher />
                    </NavigationMenuItem>
                    <NavigationMenuItem>
                      <Link to="/trusts">
                        <NavigationMenuLink
                          className={cn(
                            navigationMenuTriggerStyle(),
                            "w-[246px] justify-start",
                          )}
                          active={"/trusts" === pathname}
                        >
                          Trusts
                        </NavigationMenuLink>
                      </Link>
                    </NavigationMenuItem>

                    {amlCTFEnable && (
                      <Collapsible
                        asChild
                        defaultOpen={
                          pathname?.includes("/vendors") ||
                          pathname?.includes("/contacts")
                            ? true
                            : false
                        }
                        className="group/collapsible"
                      >
                        <NavigationMenuItem>
                          <CollapsibleTrigger asChild>
                            <NavigationMenuLink
                              className={cn(
                                navigationMenuTriggerStyle(),
                                "w-[246px] justify-between",
                              )}
                            >
                              <span>{"Contact Hub"}</span>
                              <ChevronRight className="ml-1 h-3 w-3 transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                            </NavigationMenuLink>
                          </CollapsibleTrigger>
                          <CollapsibleContent>
                            <SidebarMenuSub className="mt-2">
                              {orgContactMenu?.map((item) => (
                                <ListItem
                                  key={item.title}
                                  title={item.title}
                                  href={item.href}
                                  active={item.href === pathname ? true : false}
                                  className="px-2 py-1.5 whitespace-nowrap"
                                />
                              ))}
                            </SidebarMenuSub>
                          </CollapsibleContent>
                        </NavigationMenuItem>
                      </Collapsible>
                    )}

                    <Collapsible
                      asChild
                      defaultOpen={
                        pathname?.includes("/cashbook-report") ||
                        pathname?.includes("/statement-report") ||
                        pathname?.includes("/general-ledger-report") ||
                        pathname?.includes("/trial-balance-report") ||
                        pathname?.includes("/financial-report") ||
                        window.location.search?.includes(
                          "tab=monthly-bank-reconciliation",
                        )
                          ? true
                          : false
                      }
                      className="group/collapsible"
                    >
                      <NavigationMenuItem>
                        <CollapsibleTrigger asChild>
                          <NavigationMenuLink
                            className={cn(
                              navigationMenuTriggerStyle(),
                              "w-[246px] justify-between",
                            )}
                          >
                            <span>{"Reports"}</span>
                            <ChevronRight className="ml-1 h-3 w-3 transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                          </NavigationMenuLink>
                        </CollapsibleTrigger>
                        <CollapsibleContent>
                          <SidebarMenuSub className="mt-2">
                            {reportMenu?.map((item) => (
                              <ListItem
                                key={item.title}
                                title={item.title}
                                href={item.href}
                                active={item.href === pathname ? true : false}
                                className="px-2 py-1.5 whitespace-nowrap"
                              />
                            ))}
                          </SidebarMenuSub>
                        </CollapsibleContent>
                      </NavigationMenuItem>
                    </Collapsible>

                    <Collapsible
                      asChild
                      defaultOpen={
                        pathname?.includes("/users") ||
                        pathname?.includes("/offices") ||
                        pathname?.includes("/general-settings") ||
                        pathname?.includes("/opening-balances")
                          ? true
                          : false
                      }
                      className="group/collapsible"
                    >
                      <NavigationMenuItem>
                        <CollapsibleTrigger asChild>
                          <NavigationMenuLink
                            className={cn(
                              navigationMenuTriggerStyle(),
                              "w-[246px] justify-between",
                            )}
                          >
                            <span>{"Settings"}</span>
                            <ChevronRight className="ml-1 h-3 w-3 transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                          </NavigationMenuLink>
                        </CollapsibleTrigger>
                        <CollapsibleContent>
                          <SidebarMenuSub className="mt-2">
                            {settingsMenu?.map((item) => (
                              <ListItem
                                key={item.title}
                                title={item.title}
                                href={item.href}
                                active={item.href === pathname ? true : false}
                                className="px-2 py-1.5 whitespace-nowrap"
                              />
                            ))}
                          </SidebarMenuSub>
                        </CollapsibleContent>
                      </NavigationMenuItem>
                    </Collapsible>

                    <NavigationMenuItem>
                      <Link to={`/aml-ctf`}>
                        <NavigationMenuLink
                          className={cn(
                            navigationMenuTriggerStyle(),
                            "w-[246px] justify-start",
                          )}
                          active={"/aml-ctf" === pathname}
                        >
                          AML/CTF
                        </NavigationMenuLink>
                      </Link>
                    </NavigationMenuItem>
                  </NavigationMenuList>
                )}
              </NavigationMenu>
            </nav>
          </SheetContent>
        </Sheet>
        <div className="flex w-full items-center gap-4 md:ml-auto md:gap-2 justify-end">
          <ThemeToggle />
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="secondary" size="icon" className="rounded-md">
                <Avatar className="h-8 w-8 rounded-lg">
                  <AvatarImage src={user.avatar} alt={user.name} />
                  <AvatarFallback className="rounded-lg">
                    {user.initials}
                  </AvatarFallback>
                </Avatar>
                <span className="sr-only">Toggle user menu</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
              side={"bottom"}
              align="end"
              sideOffset={4}
            >
              <DropdownMenuLabel className="p-0 font-normal">
                <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                  <Avatar className="h-8 w-8 rounded-lg">
                    <AvatarImage src={user.avatar} alt={user.name} />
                    <AvatarFallback className="rounded-lg">
                      {user.initials}
                    </AvatarFallback>
                  </Avatar>
                  <div className="grid flex-1 text-left text-sm leading-tight">
                    <span className="truncate font-semibold">{user.name}</span>
                    <span className="truncate text-xs">{user.email}</span>
                  </div>
                </div>
              </DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuGroup>
                <DropdownMenuItem
                  className="gap-2"
                  onClick={() => navigate("/account-settings")}
                >
                  <Link
                    to={"/account-settings"}
                    className="flex items-center gap-2"
                  >
                    <BadgeCheck />
                    Account
                  </Link>
                </DropdownMenuItem>
              </DropdownMenuGroup>
              <DropdownMenuSeparator />
              {roleType !== "Admin" && (
                <>
                  <DropdownMenuGroup>
                    <DropdownMenuItem
                      onClick={() =>
                        navigate("/general-settings?tab=subscription")
                      }
                      className="gap-2"
                    >
                      <Link
                        to={"/general-settings?tab=subscription"}
                        className="flex items-center gap-2"
                      >
                        <Sparkles />
                        Subscription
                      </Link>
                    </DropdownMenuItem>

                    <DropdownMenuItem
                      className="gap-2"
                      onClick={() =>
                        navigate("/general-settings?tab=subscription-details")
                      }
                    >
                      <Link
                        to={"/general-settings?tab=subscription-details"}
                        className="flex items-center gap-2"
                      >
                        <CreditCard />
                        Billing
                      </Link>
                    </DropdownMenuItem>
                  </DropdownMenuGroup>
                  <DropdownMenuSeparator />
                </>
              )}
              <DropdownMenuItem className="gap-2" onClick={() => logOut()}>
                <LogOut />
                Log out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
          {/* <form className="ml-auto flex-1 sm:flex-initial">
            <div className="relative">
              <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
              <Input
                type="search"
                placeholder="Search..."
                onChange={handleSearch}
                value={query}
                className="pl-8 sm:w-[300px] md:w-[246px] lg:w-[300px]"
              />
              {filteredResults.length > 0 ? (
                <ul className="absolute z-10 bg-primary-foreground border w-full mt-1 rounded-lg shadow-md max-h-60 overflow-auto">
                  {filteredResults.map((route, index) => (
                    <li key={index}>
                      <Link
                        to={route.path}
                        className="block px-4 py-2 hover:bg-muted/50"
                        onClick={() => {
                          setQuery("");
                          setFilteredResults([]);
                        }}
                      >
                        {route.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              ) : (
                query && (
                  <ul className="absolute z-10 bg-primary-foreground border w-full mt-1 rounded-lg shadow-md max-h-60 overflow-auto">
                    <li className="block px-4 py-2 hover:bg-muted/50">
                      No Results
                    </li>
                  </ul>
                )
              )}
            </div>
          </form> */}
        </div>
      </header>
    </div>
  );
}

const ListItem = React.forwardRef(
  ({ className, title, children, href, active, ...props }, ref) => {
    return (
      <li>
        <NavigationMenuLink asChild>
          <Link to={href} passHref legacyBehavior>
            <a
              ref={ref}
              className={cn(
                "block select-none space-y-1 rounded-sm p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground" +
                  (active ? " bg-webPrimary text-white" : ""),
                className,
              )}
              {...props}
            >
              <div className="text-sm font-medium leading-none">{title}</div>
              <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                {children}
              </p>
            </a>
          </Link>
        </NavigationMenuLink>
      </li>
    );
  },
);
ListItem.displayName = "ListItem";
